import React, { useState, useEffect, useRef } from "react" ;
import axios from 'axios'
import PaypalCheckoutMain from "./PaypalCheckoutMain";
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";

const PaypalCheckoutHSK5 = () => {
   
    return (
        <PaypalCheckoutMain
        amountTotal="41.00"
        hsk="_hsk5"
        hskNumber="5"
      />
    );
}

export default PaypalCheckoutHSK5